import type { SVGProps } from 'react';

const SvgSortOldest = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 3.94h-1c0-.55-.45-1-1-1s-1 .45-1 1H9c0-.55-.45-1-1-1s-1 .45-1 1H6c-1.65 0-3 1.35-3 3v11c0 1.65 1.35 3 3 3h6c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1v-8h14c0 .55.45 1 1 1s1-.45 1-1v-3c0-1.65-1.35-3-3-3m-13 4v-1c0-.55.45-1 1-1h1c0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1h1c.55 0 1 .45 1 1v1z"
    />
    <path
      fill="currentcolor"
      d="M8.71 12.23q-.15-.135-.33-.21a.92.92 0 0 0-.76 0q-.18.075-.33.21c-.18.19-.29.45-.29.71s.11.52.29.71q.15.135.33.21c.12.05.25.08.38.08s.26-.03.38-.08.23-.12.33-.21c.18-.19.29-.45.29-.71s-.11-.52-.29-.71m-.33 2.79a.92.92 0 0 0-.76 0q-.18.075-.33.21c-.18.19-.29.45-.29.71s.11.52.29.71q.15.135.33.21c.12.05.25.08.38.08s.26-.03.38-.08.23-.12.33-.21c.18-.19.29-.45.29-.71s-.11-.52-.29-.71q-.15-.135-.33-.21m1.91-2.79q-.135.15-.21.33c-.05.12-.08.25-.08.38 0 .07 0 .13.02.19 0 .07.03.13.06.19.02.06.05.12.09.17.04.06.08.11.12.16.19.18.45.29.71.29.13 0 .26-.03.38-.08q.195-.075.33-.21c.04-.05.09-.1.12-.16.04-.05.07-.11.09-.17.03-.06.05-.12.06-.19 0-.06.02-.12.02-.19 0-.13-.03-.26-.08-.38s-.12-.23-.21-.33c-.37-.37-1.04-.37-1.42 0m7.35 0a1 1 0 0 0-.33-.22c-.12-.05-.25-.07-.37-.08-.13 0-.25.03-.37.08s-.23.12-.33.22l-3 3a.996.996 0 1 0 1.41 1.41l1.29-1.29v4.59c0 .55.45 1 1 1s1-.45 1-1v-4.59l1.29 1.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-3-3z"
    />
  </svg>
);
export default SvgSortOldest;
